import { ButtonProps, Button } from '@mui/material'
import React from 'react'

export default React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => (
  <Button
    ref={ref}
    color={'primary'}
    {...props}
    variant="contained"
    sx={{
      borderRadius: '4px',
      fontSize: '16px',
      height: '36px',
      boxSizing: 'border-box',
      ...props.sx,
    }}
  />
))
